import { selfAxios } from "../../../../axios/selfAxios.js";
async function opPostQueryProductMappingOrderRuleList(params) {
  const res = await selfAxios.post(`/designordercenter/linkage/queryProductMappingOrderRuleList`, params);
  return res.data;
}
export { opPostQueryProductMappingOrderRuleList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/linkage/queryProductMappingOrderRuleList/post.js